module.exports = __webpack_public_path__ + "images/leasing-calculator__select-vector-0bad103089a1420569e5231b1bd46dd7.svg";